const defaultConfig = {
  apiBase: 'https://fz.kpvpn.cc',
  appVersion: 'web-1.0.0',
  companyName: '鲲鹏VPN',
  contactEmail: 'kunpengvpn@gmail.com',
  telegramUrl: 'https://t.me/wudicms',
  iosDownload: 'https://apps.apple.com/app/apple-store/id6452237648',
  code: '',
  agentId: '',
  channel: '',
  downloads: {
    windows: '',
    macos: '',
    android: '',
    ios: '',
  },
  crispWebsiteId: '',
}

export function getConfig() {
  const runtime = (typeof window !== 'undefined' && window.__KP_CONFIG__) || {}
  const merged = {
    ...defaultConfig,
    ...runtime,
    downloads: {
      ...defaultConfig.downloads,
      ...(runtime.downloads || {}),
    },
  }
  if (typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost') {
    merged.apiBase = ''
  }
  return merged
}

export function applyLegacyStaticConfig() {
  const config = getConfig()
  window.StaticConfig = {
    pc_download: config.downloads.windows,
    mac_download: config.downloads.macos,
    android_download: config.downloads.android,
    ios_download: config.iosDownload || config.downloads.ios,
  }
}
